import { config } from "./Config"

export function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
}

export async function requestDelay() {
    if (config.requestDelay && config.requestDelay > 0) {
        await new Promise(res => setTimeout(res, config.requestDelay))
    }
}

export const statusMessage = {
    'created': { icon: 'fas fa-hourglass-half', label: 'Preparing', message: 'Your request has been submitted successfully and will be processed shortly.' },
    'await_invoice': { icon: 'fas fa-hourglass-half', label: 'Processing', message: 'Your request is currently being processed.' },
    'ready_for_download': { icon: 'fas fa-hourglass-half', label: 'Processing', message: 'Your request is currently being processed.' },
    'ready_for_archive': { icon: 'fas fa-hourglass-half', label: 'Processing', message: 'Your request is currently being processed.' },
    'await_archive': { icon: 'fas fa-hourglass-half', label: 'Processing', message: 'Your request is currently being processed.' },
    'finished': { icon: 'fas fa-check-circle', label: 'Finished', message: 'Your request has been processed successfully.' },
    'failed': { icon: 'fas fa-times-circle', label: 'Failed', message: 'Unfortunately, your request could not be processed successfully.' }
}
